export { default as cat } from './cat.png';
export { default as lifeGuard } from './life-guard.png';
export { default as coding } from './coding.png';
export { default as medical } from './medical.png';
export { default as professor } from './professor.png';
export { default as fellow } from './elearning.png';



// WEBPACK FOOTER //
// ./src/components/imgPng/index.js